import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '@env';
import { loadLazyStyles, startTracking } from '@qtek/libs/app-component';
import 'hammerjs';
import { AppModule } from './app/app.module';
import './locales';

import { datadogRum } from '@datadog/browser-rum';
if (environment.dataDogRumEnabled) {
  datadogRum.init({
    applicationId: environment.dataDogRumApiId,
    clientToken: environment.dataDogRumClientToken,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: environment.dataDogRumService,
    env: environment.dataDogRumEnv,
    sessionSampleRate: environment.dataDogRumSessionSampleRate,
    sessionReplaySampleRate: environment.dataDogRumSessionReplaySampleRate,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
}

startTracking(environment);
loadLazyStyles(environment.appName);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
// .catch(err => console.log(err));
